
import { defineComponent, nextTick, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    receiver: {
      type: Object,
      required: true
    }
  },

  setup () {
    const listInfoRef = ref()
    const listInfoAmountRef = ref()
    const listInfoAddressRef = ref()
    const listAmountFontSize = ref(18)

    function checkAmountClientWidth () {
      console.log(listInfoAmountRef.value.clientWidth, listInfoAddressRef.value.clientWidth, listInfoRef.value.clientWidth, listAmountFontSize.value)

      nextTick(() => {
        if (listInfoAmountRef.value.clientWidth + listInfoAddressRef.value.clientWidth > listInfoRef.value.clientWidth) {
          listAmountFontSize.value = listAmountFontSize.value - 1
        } else {
          return
        }

        checkAmountClientWidth()
      })
    }

    onMounted(() => {
      checkAmountClientWidth()
    })

    return {
      listInfoAmountRef,
      listInfoAddressRef,
      listInfoRef,
      listAmountFontSize
    }
  }
})
